import { Theme, css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButtonProps } from './DefaultButton.types';

export interface StyledButtonProps {
  size: DefaultButtonProps['size'];
  colorType: NonNullable<DefaultButtonProps['colorType']>;
  isLoading: DefaultButtonProps['isLoading'];
  isLeftIcon: DefaultButtonProps['isLeftIcon'];
  isRightIcon: DefaultButtonProps['isRightIcon'];
}

const getButtonSize = (size: StyledButtonProps['size']) => {
  switch (size) {
    case 'small':
      return css`
        height: 32px;
      `;
    case 'medium':
    default:
      return css`
        height: 44px;
      `;
  }
};

const fontStyle = (theme: Theme, colorType: StyledButtonProps['colorType']) => {
  switch (colorType) {
    case 'black':
      return css`
        color: ${theme.content.content_light_1};
        ${theme.fontStyle.text.body18_medium};
      `;

    case 'main':
    default:
      return css`
        color: ${theme.content.content_dark_1};
        ${theme.fontStyle.text.body18_medium};
      `;
  }
};

const getButtonStyle = (
  colorType: StyledButtonProps['colorType'],
  theme: Theme,
) => {
  switch (colorType) {
    case 'black':
      return css`
        border: 1px solid ${theme.stroke.stroke_2};
        border-radius: 24px;
        background: ${theme.backgroundColor.bg_light_5_alpha};
        backdrop-filter: blur(50px);
        ${fontStyle(theme, 'black')};
      `;
    case 'main':
    default:
      return css`
        border-radius: 22px;
        background: ${theme.themeColor.main_1};
        ${fontStyle(theme, 'main')};
      `;
  }
};

export const Button = styled.button<StyledButtonProps>`
  ${({
    theme,
    size = 'medium',
    colorType = 'main',
    isLoading,
    isLeftIcon,
    isRightIcon,
  }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-right: ${isRightIcon ? '8px' : '16px'};
    padding-left: ${isLeftIcon || isLoading ? '8px' : '16px'};
    transition: background 0.1s ease-in-out;
    white-space: nowrap;
    gap: 4px;

    ${getButtonSize(size)};
    ${getButtonStyle(colorType, theme)};

    .sp {
      border-color: currentColor;
      border-top-color: transparent;
    }

    ${isLoading && { pointerEvents: 'none' }}

    &:disabled {
      border: 1px solid ${theme.stroke.stroke_1};
      border-radius: 22px;
      background: ${theme.backgroundColor.bg_dark_3};
      color: ${theme.content.content_light_5};
      cursor: not-allowed;
    }
  `}
`;
